import { forecastQuery } from "@common/api/forecast"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { requireForecastPages } from "@/routes/_layout/forecasts/-lib/gate"
import { DueList } from "./-components/due-list"
import { COLUMNS } from "./-lib/columns"
import { FILTER_KEYS } from "./-lib/filters"
import { dueSearchSchema, GROUPINGS } from "./-lib/search"
import { useUpdateSearch } from "./-lib/use-update-search"

export const Route = createFileRoute("/_layout/forecasts_/$forecastId")({
  validateSearch: (search) => dueSearchSchema.parse(search),
  loaderDeps: ({ search: { basis } }) => ({ basis }),
  beforeLoad: ({ context: { queryClient } }) =>
    requireForecastPages(queryClient),
  loader: async ({
    context: { queryClient },
    params: { forecastId },
    deps: { basis },
  }) => {
    const forecast = await queryClient.ensureQueryData(
      forecastQuery({ forecast_id: forecastId, basis }),
    )
    return {
      breadcrumb: [
        { label: "Forecast", href: "/forecasts" },
        { label: `${forecast.number} · ${forecast.name}` },
      ],
    }
  },
  component: ForecastPage,
})

function ForecastPage(): React.ReactElement {
  const { forecastId } = Route.useParams()
  const search = Route.useSearch()
  const update = useUpdateSearch()
  const { data: forecast } = useSuspenseQuery(
    forecastQuery({ forecast_id: forecastId, basis: search.basis }),
  )

  return (
    <DueList
      result={forecast.result}
      search={search}
      columns={COLUMNS}
      groupings={GROUPINGS}
      filterKeys={FILTER_KEYS}
      basis={forecast.result.basis}
      forecastId={forecastId}
      newWorkOrder
      onSearch={update}
      onBasis={(next) =>
        update({ basis: next === forecast.basis ? undefined : next })
      }
    />
  )
}
